import React from 'react'
import { Modal } from 'react-bootstrap'

const ModalBox = (props) => {
  return (
    <Modal
      {...props}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className='modal-j32'
    >
      <Modal.Header>
        <span className='text-center w-100'>{props.title}</span>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  )
}
export default ModalBox
